import { ART_EVENT_STATUS } from '../constants/artEventStatus';
import { ACTION_TYPES } from '../constants/actionTypes';

export const MODAL_CONFIGS = [
  {
    type: ACTION_TYPES.FREEZE,
    titleKey: 'freeze-art-event-title',
    messageKey: 'freeze-art-event-message',
    confirmButtonKey: 'yes-button',
    successMessageKey: 'art-event-frozen-successfully',
    errorMessageKey: 'art-event-freeze-failed',
    status: ART_EVENT_STATUS.FROZEN,
  },
  {
    type: ACTION_TYPES.DELETE,
    titleKey: 'delete-art-event-title',
    messageKey: 'delete-art-event-message',
    confirmButtonKey: 'yes-button',
    successMessageKey: 'art-event-deleted-successfully',
    errorMessageKey: 'art-event-delete-failed',
    status: ART_EVENT_STATUS.DELETED,
  },
  {
    type: ACTION_TYPES.ACTIVATE,
    titleKey: 'activate-art-event-title',
    messageKey: 'activate-art-event-message',
    confirmButtonKey: 'yes-button',
    successMessageKey: 'art-event-activated-successfully',
    errorMessageKey: 'art-event-activate-failed',
    status: ART_EVENT_STATUS.ACTIVE,
  },
];
